import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { StateChoiceDialogData } from './models/state_choice_dialog_data';

@Component({
    selector: 'app-state-choice-dialog',
    imports: [MatCardModule, MatFormFieldModule, MatSelectModule, FormsModule, ReactiveFormsModule, MatOptionModule, MatButtonModule, MatDialogClose],
    templateUrl: './state-choice-dialog.component.html',
    styleUrl: './state-choice-dialog.component.scss'
})
export class StateChoiceDialogComponent {
    /**
     * Contrôle de formulaire pour saisir le commentaire.
     */
    public stateControl = new UntypedFormControl(null, [Validators.required]);

    /**
     * Constructeur.
     * @param dialogRef
     */
    constructor(
        public dialogRef: MatDialogRef<StateChoiceDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: StateChoiceDialogData
    ) {}

    /**
     * Appelé lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }
}
